module.exports = __webpack_public_path__ + "img/190566.246fc4d8.jpg";